'use client';

import styled from 'styled-components';

import { colors } from '@/styles/theme';

export const Container = styled.div`
  background-color: #fff;
  padding: 3rem 2rem 0;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const Title = styled.h2`
  font-size: 1.75rem;
  font-weight: 900;
  margin: 0;
  text-transform: uppercase;
  line-height: 1.2;
  color: #000;
`;

export const Subtitle = styled.p`
  margin: 1.5rem 0;
  font-size: 1.25rem;
  color: #000;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  max-width: 450px;
  margin: 0 auto;
  gap: 1rem;
`;

export const NameInputsContainer = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
`;

export const InputWrapper = styled.div`
  flex: 1;
  position: relative;
`;

export const Input = styled.input`
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  outline: none;

  &:focus {
    border-color: #9c89ff;
  }
`;

export const EmailContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 1rem;

  
  @media (max-width: 768px) {
    flex-direction: column;

    > * {
      width: 100%;
    }
  }
`;

export const EmailInput = styled.input`
  flex: 1;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  border-radius: 4px;
  border: none;
  outline: none;
  border: 1px solid #ccc;
`;

export const SubscribeButton = styled.button`
  background: linear-gradient(to bottom right, ${colors.purple}, ${colors.aqua});
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  transition: background-color 0.3s;

  &:hover {
    cursor: pointer;
    background-color: #e84db3;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

export const SubscriberCount = styled.p`
  margin-top: 1rem;
  font-size: 0.9rem;
  color: #000;
`;

export const ConsentMessage = styled.div`
  font-size: 0.75rem;
  color: #666;
  font-style: italic;

  text-align: center;
  padding: 2rem 0 1rem;
`;

export const OverlayContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.3s ease,
    visibility 0.3s ease;

  &.visible {
    opacity: 1;
    visibility: visible;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  background: white;
  border: none;
  border-radius: 50%;
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1001;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
`;
